<script lang="ts">
  import OVIcon from "$components/+shared/OVIcon/OVIcon.svelte";
  import { communitySlug } from "$stores/community";
  import type { WritableDocument } from "app/models/documents";
  import { localStorageStore } from "$stores/localStorage";
  import { accordion } from "app/actions/accordion";
  import KBNavItem from "./KBNavItem.svelte";
  import cx from "classnames";
  import { page } from "$app/stores";
  import { fadeSlide } from "app/transitions";
  import { DashedCircle, Right } from "$components/+shared/OVIcon";

  const ANIMATION_DURATION_MS = 110;

  export let drafts: WritableDocument[];

  // we persist the expansion state of the space group in local storage
  let isExpanded = localStorageStore(`drafts-${$communitySlug}-expansion`, true);
</script>

<button
  class="flex w-full items-center gap-2 py-1.5 pl-2 pr-2.5 text-orange-500/90 transition-colors duration-75 hover:text-orange-500 dark:text-orange-400/75 dark:hover:text-orange-400/90"
  on:click={() => ($isExpanded = !$isExpanded)}
>
  <OVIcon icon={DashedCircle} />
  <span class="text-sm font-medium md:text-[13px]">Unpublished</span>
  <OVIcon
    icon={Right}
    size="size-3.5"
    class={cx(" ml-auto transition-transform duration-75", $isExpanded ? "rotate-90" : "rotate-0")}
    aria-expanded={$isExpanded}
  />
</button>

<nav
  class="no-scrollbar mb-5"
  use:accordion={{ isOpen: $isExpanded, duration: ANIMATION_DURATION_MS }}
>
  {#each drafts as document (document.uuid)}
    <div
      class={cx(
        "ml-4 border-l pl-2 pr-0.5 transition-colors duration-500 ease-out",
        $page.url.pathname.includes(document.uuid)
          ? "border-community-primary"
          : "border-black/10 dark:border-white/10"
      )}
      transition:fadeSlide={{ duration: 200 }}
    >
      <KBNavItem communitySlug={$communitySlug} {document} />
    </div>
  {/each}
</nav>
